import styled, { css } from 'styled-components';
import { ToastContainer } from 'react-toastify';
import { media } from 'src/common/styles/breakpoints';

export const CustomToastContainer = styled(ToastContainer)`
  &.Toastify__toast-container {
    width: fit-content;
    padding: 0;

    ${media.w.max.any(480)(css`
      top: 1em;
      left: 50%;
      max-width: calc(100% - 8px);
      transform: translateX(-50%);
    `)}
  }

  .Toastify__toast {
    padding: 0;
    background-color: transparent;
    box-shadow: none;
  }

  .Toastify__toast-body {
    padding: 0;
    box-shadow: ${({ theme }) => theme.shadows.drop1};
  }

  .Toastify__progress-bar {
  }
`;
